import {useGetData} from '../../src/apiservice/apiCall'


export function useProductMenu(){
	return useGetData('/api/WebApi/GetProductMenu')
}
